// Brand artwork for the customer dashboard chrome (CB-12, INF-1). Lives in theme/ with
// the rest of the white-label bundle: a different tenant swaps these PNGs (and
// tokens.ts `brand`), nothing else in the surface changes. Copied from the customer
// design export (claude-design-raw-html/customer-dashboard/assets/) — the lockup has a
// light and a reversed (dark-theme) variant; theme.css `--rail-logo` / `--rail-logo-rev`
// decide which one shows. The designer credit mark is deliberately not shipped.
import lockup from './assets/brand-lockup.png';
import lockupReversed from './assets/brand-lockup-rev.png';
import mark from './assets/brand-mark.png';
import markReversed from './assets/brand-mark-rev.png';

export const brandAssets = {
  /** Full lockup for light surfaces (rail in the light theme). */
  lockup,
  /** Reversed lockup for dark surfaces (rail in the dark theme). */
  lockupReversed,
  /** Square app mark (mobile top bar, Home's QR button). */
  mark,
  /** Reversed square mark for dark surfaces (Home's QR button in the dark theme, DC61). */
  markReversed,
} as const;
